import React from 'react';

import styled from '@mui/styles/styled';

import { DatePickerProps, DatePicker as MuiDatePicker } from '@mui/x-date-pickers';

import { TextFieldProps } from '@mui/material/TextField';
import { IconButtonProps } from '@mui/material/IconButton';
import { Styling, Colors } from '../../../constants';

interface IDatePickerProps {
  id?: string,
}

export const DatePicker = styled(MuiDatePicker)<IDatePickerProps & DatePickerProps<Date>>({
  'border-radius': `${Styling.DEFAULT_BORDER_RADIUS}px`,
  'margin-left': `${Styling.DEFAULT_SPACING_HALVED}px`,
  'background-color': 'rgba(255, 255, 255, 0.25)',

  'max-width': '152px',
  'flex-grow': 0,
});

export const DatePickerInputStyles: TextFieldProps['InputProps'] = {
  disableUnderline: true,
  style: {
    color: Colors.WHITE_80,
    fontSize: 14,
  },
};

export const DatePickerButtonProps: Partial<IconButtonProps> = {
  color: 'inherit',
};
